import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 6px;
  height: 184px;
  pointer-events: none;
`